import React, { memo } from 'react';
import styles from './styles.module.scss';

var Button = function Button(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type;
  return (
    /*#__PURE__*/
    React.createElement("button", {
      className: [styles.root, styles[type]].join(' '),
      onClick: onClick
    }, children)
  );
};

export default memo(Button);